module.exports = __webpack_public_path__ + "static/media/14-8.38ad2128.mp3";